import { Component, Output,Input, EventEmitter,ElementRef,ViewChild,HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { AddressDialogComponent } from '../NewServiceRequest/address-dialog/address-dialog.component';
import { AgentscriptService_updated } from 'src/app/services/agent-script-service/agent-script-service';
import { loadModules } from 'esri-loader';
import { ObjectController } from '../services/object-controller/objectcontroller.service';
import { GoogleMapComponent } from '../NewServiceRequest/google-map/google-map.component';
import { EsriMapComponent } from '../NewServiceRequest/esri-map/esri-map.component';
import { StandardUIService } from '../services/standardui-service/standardui-service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FileuploadService } from '../services/FileUpload/fileupload.service';
import { AttachmentsService } from '../services/attachments-service/attachments-service';
import { LocalStorageService } from '../services/localstorage-service/localstorage-service';
import html2canvas from 'html2canvas';

declare var $: any;

@Component({
  selector: 'app-alert-incident',
  templateUrl: './alert-incident.component.html',
  styleUrls: ['./alert-incident.component.scss']
})
export class AlertIncidentComponent {
  @ViewChild('confirmationModal') confirmationModal!: ElementRef;
  @ViewChild(GoogleMapComponent) GoogleMapComponent!: GoogleMapComponent;
  @ViewChild(EsriMapComponent) EsriMapComponent!: EsriMapComponent;
  class1Active: boolean = true;
  class2Active: boolean = false;
  isDisassociated: boolean = false;

  contextid={"id":null}


  fileToUpload: File[] = [];
  // handleFileInput(files: FileList) {
  //   const maxSize = 10 * 1024 * 1024

  //   for (let i = 0; i < files.length; i++) {
  //     this.fileToUpload.push(files.item(i));  // Correctly add files to the array
  //     console.log(files.item(i));
  //     console.log(this.fileToUpload);

  //     if(files.item(i).size > maxSize)
  //     {
  //       this.errorforupload(files.item(i))
  //       break;
  //     }
  //   }
  // }
  // imgUrl:any=[]
  // fileToUpload: File;

  handleFileInput(files: FileList) {
    const maxSize = 10 * 1024 * 1024

    // if (this.incidentW.type == '1') {
    //     this.imgUrl = [];
    // }
    // const initialLength = this.imgUrl.length;

    for (let i = 0; i < files.length; i++) {


      if(files[i].size > maxSize)
        {
          this.errorforupload(files.item(i))
        }
      else
      {
        this.fileToUpload.push(files.item(i))
        // this.fileToUpload = files[i];
        // this.imgUrl.push(files.item(i));
        console.log(this.fileToUpload)
        // console.log(this.imgUrl)
        // this.fileUploadService.upload(this.fileToUpload).subscribe(response => {
        //   this.imgUrl.push(response);
        //   if (this.imgUrl.length === initialLength + files.length) {
        //     let concatenatedUrls = "";
        //     for (let j = 0; j < this.imgUrl.length; j++) {
        //       if (this.isImageUrl(this.imgUrl[j])) {
        //         concatenatedUrls += `<a href="${this.imgUrl[j]}" target="_blank"><img src="${this.imgUrl[j]}" alt="Image" class="img-fluid"/></a><br>`;

        //       } else {
        //         let arr:any = this.imgUrl[j].split('sections/')[1].split('_');
        //         arr.splice(0, 2);
        //         // Join the remaining elements with an underscore
        //         const result = arr.join('_');
        //         // Output the result
        //         console.log(result);
        //         concatenatedUrls += `<a href="${this.imgUrl[j]}" target="_blank">${result}</a><br>`;
        //       }
        //     }
        //     // const currentMessage = this.EmailForm.get("message").value || this.EmailForm.get("message").value || '';
        //     // const newMessage = currentMessage ? `${currentMessage}\n${concatenatedUrls}` : concatenatedUrls;

        //     // if (this.incidentW.type == '2' && this.incidentW.type == '1') {
        //     //     this.EmailForm.patchValue({ 'message': newMessage });
        //     // } else if (this.incidentW.type == '1') {
        //     //     this.EmailForm.patchValue({ 'message': newMessage });
        //     // }

        //   }
        // });
      }
    }
  }
  // private screenshotCounter: number = 1;
  @HostListener('paste', ['$event'])
  handlePaste(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the default paste behavior
    const items = event.clipboardData?.items;
    if (items) {
      let imageProcessed = false;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.startsWith('image/') && !imageProcessed) {
          const file = items[i].getAsFile();
          if (file) {
            const reader = new FileReader();
            reader.onload = (e: ProgressEvent<FileReader>) => {
              const img = document.createElement('img');
              img.src = e.target?.result as string;
              img.style.maxWidth = '100%';
              img.style.height = 'auto';
              const base64Data = img.src.split(',')[1];

              // Convert base64 data to a Blob (correctly handling the base64)
              const byteString = atob(base64Data);
              const arrayBuffer = new ArrayBuffer(byteString.length);
              const uint8Array = new Uint8Array(arrayBuffer);

              for (let j = 0; j < byteString.length; j++) {
                uint8Array[j] = byteString.charCodeAt(j);
              }

              const blob = new Blob([uint8Array], { type: 'image/png' });

              // Create a File object from the Blob
              const fileToUpload = new File([blob], 'screenshot.png', { type: 'image/png' });

              // const fileName = `screenshot${this.screenshotCounter}.png`;
              // const fileToUpload = new File([blob],  fileName, { type: 'image/png' });

              // this.screenshotCounter++;

             this.fileToUpload.push(fileToUpload);
             console.log("base64file11111",this.fileToUpload)

              const div = this._elementRef.nativeElement.querySelector('#pasted-content');
              div.innerHTML = '';
              div.appendChild(img);
              imageProcessed = true;
            };
            reader.readAsDataURL(file);
            // break;
          }
        }else if (items[i].type === 'text/plain' && !imageProcessed) {
            // Handle plain text paste
            items[i].getAsString((text) => {
              const div = this._elementRef.nativeElement.querySelector('#pasted-content');
              div.innerHTML = '';
              div.append(text);
            });
          }

      }
    }
  }
  clearPastedContent() {
    const div = this._elementRef.nativeElement.querySelector('#pasted-content');
    div.innerHTML = ''; // Clear the content of the pasted-content div
  }
  attachfile()
  {
    console.log(this.fileToUpload)

      for(let i=0;i<this.fileToUpload.length;i++)
        {
          this.fileUploadService.upload(this.fileToUpload[i]).subscribe(response => {

        console.log("without base64",response);
            let payload = {
              entityName: "Attachment",
              "payLoad": {
                "Attachment.attachfiles": response,
                "Attachment.incidentid": this.contextid.id,
              }
            }
            console.log(payload);
            this.attachmentsService.entityCreate(payload).subscribe(result => {
              console.log(result);
              this.fileToUpload=null;
             this.ngOnInit();
             this.clearPastedContent();
            }),
            error => {
              alert('error')
            }
          });
        }


  }

  deleteUrl(index: number) {
    Swal.fire({

      title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Are you sure?</div></div>',
      imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
      imageHeight: 45,
      text: 'You want to permanently delete this file?',
      icon: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: '#275a8a',
      confirmButtonText: '<i class="bi bi-check-lg"></i>  Yes, delete it!',
      cancelButtonText: '<i class="bi bi-x-lg"></i>  Cancel'
    }).then((result) => {
     console.log(result)
      if (result.value) {
        // this.imgUrl.splice(index, 1);
        this.fileToUpload.splice(index, 1);
        // this.fileInput.nativeElement.value = '';
        Swal.fire(
          '<div style="text-align:center;width: 100%;"> Deleted!</div>',
          'Your file has been deleted.',
          'success'
        )
        const div = this._elementRef.nativeElement.querySelector('#pasted-content');
        div.innerHTML = '';
      }
    })
  }

  @ViewChild('fileInput') fileInput: ElementRef;

  errorforupload(file:any)
  {
    Swal.fire({
      title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Something went wrong.<br>The below file exceeds the size limit. Please upload a file less than 15 MB.<br>If problem persists please contact support.</div></div>',
      html:file.name,
      icon: 'error',
      imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
      imageHeight: 45,
      showCloseButton: true,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: `OK`,
      cancelButtonText: 'Cancel'
    })
    if (this.fileInput) {
      // this.fileToUpload = [];
      // this.fileInput.nativeElement.value = ''; // Clear the file input element
    }
  }

  testswal()
  {
    // Swal.fire({
    //   title: '<div class="popup-content"><img src="../../assets/images/logo-main.png"  alt="Selected Image" class="selected-image"><div class="popup-text"> <img src="../../assets/images/verified1.gif" class="animated-check" width="42px" >Something went wrong,Please try again. If problem persists please contact support.</div></div>',
    //   icon: 'info',
    //   showCloseButton: true,
    //   showCancelButton: false,
    //   focusConfirm: false,
    //   confirmButtonText: `OK`,
    //   cancelButtonText: 'Cancel'
    // })

    Swal.fire({
      title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/warning.svg" class=animated-check >Something went wrong,Please try again. If problem persists please contact support.</div></div>',
      // html:data,
      icon: 'error',
      imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
      imageHeight: 45,
      showCloseButton: true,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: `OK`,
      cancelButtonText: 'Cancel'
    })

  }
  tcontainer = {
    'height': ( $(window).height() - $('.layout-navbar').height() - 290) + 'px',
  'overflow': 'hidden',
  'overflow-y':'auto'
  };
  tcontainer1 = {
    'max-height': ( $(window).height() - $('.layout-navbar').height() - 490) + 'px',
  'overflow': 'hidden',
  'overflow-y':'auto'
  };
  tcontainer2 = {
    'max-height': ( $(window).height() - $('.layout-navbar').height() - 350) + 'px',
  'overflow': 'hidden',
  'overflow-y':'auto'
  };
  // toggleClass1() {
  //   this.class1Active = !this.class1Active;
  // }

  // toggleClass2() {
  //   this.class2Active = !this.class2Active;
  // }

@Input() serviceTypeInfo:any;
@Input() componentData:any;
@Output() componentSelection = new EventEmitter<any>();
// @Output() activeSRValues: EventEmitter<any> = new EventEmitter();

  data: any;
  receiveData(data: any) {
    this.loadMap_button=false;
    console.log(data)
    if (data.msr_addresstype == "Intersection") {
      this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue("1363")

      var fields = data.msr_serviceaddress.split('&');
      this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(fields[0])
      this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue(fields[1])
      this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue('Fort Wayne')
      this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue("IN")
    }
    else {
      this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue("1362")
      this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(data.msr_serviceaddress)
      this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue(data.msr_city)
      this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue(data.msr_state)
      // this.addressDetailsForm.get(['locationDtls','addressline2'])?.setValue(data.msr_)
    }
    this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue(data.msr_zip)
    this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue(data.msr_lng)
    this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue(data.msr_lat)
    this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue(data.msr_withinlimits)
    this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue(data.msr_jurisdiction)
    this.addressDetailsForm.get(['locationDtls', 'next_collection_day'])?.setValue(data.msr_next_collection_day)
    this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue(data.msr_zoning)
    this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue(data.msr_recycleweek);
    this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue(data.msr_collectionday)
    this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue(data.msr_parcelnumber)

    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'locationdata', this.addressDetailsForm.get(['locationDtls']).value)

    console.log(this.agentscriptservice.fetchData(this.tab_title, 'locationdata'))

    this.nearbyIncidents = data.msr_nearbyIncidents?.incidents
    this.alertIncidents = data.msr_alertIncidents?.incidents

    this.loadMap_button = false;

  }
  addressDetailsForm: FormGroup;
  isLoginInfo: boolean = false;
  isAnonymous: boolean = true;
  exampleCheck1: boolean = false;
  isLocationSearch: boolean = true;
  marked: boolean = false;
  isGisVerified: boolean = false;
  searchLocation:any;
  //esri map
  mapCenter = [-85.1392, 41.0804];
  basemapType = 'satellite';
  mapZoomLevel = 11;
  mapLoadedEvent(status: boolean) {
    console.log('The map has loaded: ' + status);
  }
  contactAddresstype:any;
  recycleWeekValue:any;
  tab_title: any;
  nearbyIncidents: any;
  alertIncidents: any
  loadMap_button = true;

  withinlimits:any=[]
  recycleweek:any=[]
  jurisdiction:any=[]
  collectionday:any=[]
  zoning:any=[]

  picklist() {
    const picklistIDs = [37, 97, 32, 38, 33]; // Array of picklist IDs
    picklistIDs.forEach(picklistID => {
      this._standardUiService.getPicklistByID(picklistID).subscribe(data => {
        const picklistValues = [];
        for (let key in data) {
          if (data[key].active === true || data[key].active === '') {
            picklistValues.push({
              "id": data[key].id,
              "value": data[key].valueen
            });
          }
        }
        if (picklistID == 37) {
          this.withinlimits.push(...picklistValues);
          // console.log(this.casesubtypeVal)
        }
        else if (picklistID == 97) {
          this.recycleweek.push(...picklistValues);
          // console.log(this.casetypeVal)
        }
        else if (picklistID == 32) {
          this.jurisdiction.push(...picklistValues);
          // console.log(this.departmentVal)
        }
        else if (picklistID == 38) {
          this.collectionday.push(...picklistValues);
          // console.log(this.servicerequest_source)
        }
        else if (picklistID == 33) {
          this.zoning.push(...picklistValues);
          // console.log(this.addresstypeVal)
        }
      });
    });
  }

  updatealertincident:any=0
  showassociatebuttons:boolean=true
  formsubmitted:boolean
  ngOnInit() {
    this.formsubmitted=false;
    this.showassociatebuttons=true
    console.log(this.componentData)
    this.picklist()
    this.updatealertincident=0
    this.addressDetailsForm = this.fb.group({
      contactDtls: this.fb.group({
        alertsubject:['', [Validators.required]],
        Furtherdetails:['', [Validators.required]]
      }),
      locationDtls: this.fb.group({
        addresstype: ['1362', [Validators.required]],
        addressline1: ['', [Validators.required]],
        addressline2: [''],
        city: ['', [Validators.required]],
        state: ['', [Validators.required]],
        latitude: ['', [Validators.required]],
        longitude: ['', [Validators.required]],
        postalcode: ['', [Validators.required]],
        withinlimits: ['', [Validators.required]],
        jurisdiction: [''],
        zoning: [''],
        recycleweek: [''],
        collectionday: [''],
        parcelnumber: [''],
        // sla: [''],
      })
    });
    this.tab_title = $(".custom-tabs li.active").find("a").attr('data-obj-title')

    console.log("in alert.ts")

    // this.componentData=this.agentscriptservice.fetchData(this.tab_title,'casetypedata')
    // console.log(this.serviceTypeInfo)
    console.log(this.componentData)
    console.log(this.agentscriptservice.fetchData(this.tab_title, 'casetypedata'))
    if(!((typeof (this.componentData?.id)=='string') && this.componentData?.id.includes('alertincident')))
      {
        // var scriptpayloaddata = this.agentscriptservice.fetchData(this.tab_title, 'scriptpayloaddata')
        this.objectcontrolservice.getObjectData(this.componentData.id,'Incident').subscribe((data:any)=>
          {
            console.log(data)
          var getdata=data.payLoad

          console.log(getdata)

        if(getdata?.addressline2!='')
          {
            this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue("1363")
            this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue(getdata?.addressline2)
          }
        this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(getdata?.addressline1)
        var addresssearch=getdata?.addressline1 + (this.addressDetailsForm.get(['locationDtls', 'addresstype']).value == '1363' ?' & '+getdata?.addressline2:'')
        // alert(addresssearch)
        if(addresssearch)
          {
            this.assignaddress(addresssearch)
            this.showassociatebuttons=false
          }
        this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue(getdata?.latitude)
        this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue(getdata?.longitude)
        this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue(getdata?.withinlimits)
        this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue(getdata?.postalcode)
        this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue(getdata?.jurisdiction)
        this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue(getdata?.zoning)
        this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue(getdata?.recycleweek)
        this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue(getdata?.collectionday)
        this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue(getdata?.parcelnumber)


        this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue("Fort Wayne")
        this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue("IN")

        this.addressDetailsForm.get(['contactDtls', 'alertsubject'])?.setValue(getdata?.subject)
        this.addressDetailsForm.get(['contactDtls', 'Furtherdetails'])?.setValue(getdata?.furtherdetails)

        this.updatealertincident=getdata?.id

        this.contextid={"id":getdata.id}

          })


        // alert(this.contextid)

      }

    this.agentscriptservice.updateOrInsertArray(this.tab_title,'casetypedata',this.componentData)


    console.log(this.agentscriptservice.AlldataArray)
    // console.log(this.nearbyIncidents)
    // this.agentscriptservice.Associated=false;

    console.log(this.agentscriptservice.fetchData(this.tab_title, 'contactdata'))
    console.log(this.agentscriptservice.fetchData(this.tab_title, 'locationdata'))

    this.data = this.componentData.serviceDetails
    // console.log("deiiiiiiiiiiiiiiii",this.data)


    // if (this.agentscriptservice.fetchData(this.tab_title, 'contactdata') != 0) {
    //   var contactdata=this.agentscriptservice.fetchData(this.tab_title, 'contactdata')
    //   console.log(contactdata)

    //   this.addressDetailsForm.get(['contactDtls', 'anonymous'])?.setValue(contactdata.anonymous);
    //   this.addressDetailsForm.get(['contactDtls', 'contact'])?.setValue(contactdata.contact);
    //   this.addressDetailsForm.get(['contactDtls', 'firstname'])?.setValue(contactdata.firstname);
    //   this.addressDetailsForm.get(['contactDtls', 'lastname'])?.setValue(contactdata.lastname);
    //   this.addressDetailsForm.get(['contactDtls', 'emailaddress'])?.setValue(contactdata.emailaddress);
    //   this.addressDetailsForm.get(['contactDtls', 'phonenumber1'])?.setValue(contactdata.phonenumber1);
    //   this.addressDetailsForm.get(['contactDtls', 'phonenumber2'])?.setValue(contactdata.phonenumber2);
    //   this.addressDetailsForm.get(['contactDtls', 'mailingadd'])?.setValue(contactdata.mailingadd);
    //   // this.addressDetailsForm.get(['contactDtls', 'serviceadd'])?.setValue(contactdata.serviceadd);

    // }

    // if (this.agentscriptservice.fetchData(this.tab_title, 'locationdata') != 0) {
    //   var locationdata=this.agentscriptservice.fetchData(this.tab_title, 'locationdata')
    //   console.log(locationdata)

    //   this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue(locationdata.addresstype);
    //   this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(locationdata.addressline1);
    //   this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue(locationdata.addressline2);
    //   this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue(locationdata.city);
    //   this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue(locationdata.state);
    //   this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue(locationdata.longitude);
    //   this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue(locationdata.latitude);
    //   this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue(locationdata.postalcode);
    //   this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue(locationdata.withinlimits);
    //   this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue(locationdata.jurisdiction);
    //   this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue(locationdata.zoning);
    //   this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue(locationdata.recycleweek);
    //   this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue(locationdata.collectionday);
    //   this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue(locationdata.parcelnumber);

    //   var mapdata = this.agentscriptservice.fetchData(this.tab_title, 'mapdata')
    //   console.log(mapdata)
    //   this.nearbyIncidents = mapdata?.nearby_incidents?.incidents
    //   this.loadMap_button=false
    // }



    // this.clearForm();
    // if (this.serviceTypeInfo && this.serviceTypeInfo.serviceDetails && this.serviceTypeInfo.serviceDetails.contactDtls) {

    //   console.log(this.agentscriptservice.fetchData(this.tab_title, 'contactdata'))
    //   this.addressDetailsForm.get(['contactDtls', 'anonymous'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.anonymous);
    //   this.addressDetailsForm.get(['contactDtls', 'contact'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.contact);
    //   this.addressDetailsForm.get(['contactDtls', 'firstname'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.firstname);
    //   this.addressDetailsForm.get(['contactDtls', 'lastname'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.lastname);
    //   this.addressDetailsForm.get(['contactDtls', 'emailaddress'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.emailaddress);
    //   this.addressDetailsForm.get(['contactDtls', 'phonenumber1'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.phonenumber1);
    //   this.addressDetailsForm.get(['contactDtls', 'phonenumber2'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.phonenumber2);
    //   this.addressDetailsForm.get(['contactDtls', 'mailingadd'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.mailingadd);
    //   this.addressDetailsForm.get(['contactDtls', 'serviceadd'])?.setValue(this.serviceTypeInfo.serviceDetails.contactDtls.serviceadd);
    //   // this.nearbyIncidents=this.serviceTypeInfo.serviceDetails.nearbyIncidents
    //   // console.log(this.serviceTypeInfo.serviceDetails)
    //   this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', this.addressDetailsForm.get(['contactDtls']).value)
    //   console.log(this.agentscriptservice.fetchData(this.tab_title, 'contactdata'))


    // }
    // if (this.serviceTypeInfo && this.serviceTypeInfo.serviceDetails && this.serviceTypeInfo.serviceDetails.locationDtls) {

    //   console.log(this.agentscriptservice.fetchData(this.tab_title, 'locationdata'))


    //   this.loadMap_button = false;

    //   this.agentscriptservice.updateOrInsertArray(this.tab_title, "associateddata", [])
    //   this.agentscriptservice.updateOrInsertArray(this.tab_title, "isassociated", false)
    //   var mapdata = this.agentscriptservice.fetchData(this.tab_title, 'mapdata')
    //   console.log(mapdata)
    //   this.nearbyIncidents = mapdata?.nearby_incidents?.incidents

    //   this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.addresstype);
    //   this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.addressline1);
    //   this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.addressline2);
    //   this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.city);
    //   this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.state);
    //   this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.longitude);
    //   this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.latitude);
    //   this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.postalcode);
    //   this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.withinlimits);
    //   this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.jurisdiction);
    //   this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.zoning);
    //   this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.recycleweek);
    //   // this.addressDetailsForm.get(['locationDtls','collectionday'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.collectionday);
    //   this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue('');
    //   this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.parcelnumber);
    //   // this.nearbyIncidents=this.serviceTypeInfo.serviceDetails.nearbyIncidents
    //   // console.log(this.serviceTypeInfo.serviceDetails)
    //   // this.addressDetailsForm.get(['locationDtls','sla'])?.setValue(this.serviceTypeInfo.serviceDetails.locationDtls.sla);
    // }
    // this.performAddressSearch(this.searchAddress);
    // this.nearbyIncidents=this.componentData.serviceDetails.nearbyIncidents
    //   console.log(this.componentData.serviceDetails)
    // if (this.apiservice.gensysdata && this.apiservice.gensysdata.geneSysData) {
    //   // Assign the firstname value from geneSysData to the corresponding form control
    //   this.addressDetailsForm.get('contactDtls.firstname')?.setValue(this.apiservice.gensysdata.geneSysData.firstname);
    //   this.addressDetailsForm.get('contactDtls.phonenumber1')?.setValue(this.apiservice.gensysdata.geneSysData.phonenumber);
    //   this.openModalPopup();
    // }
    // console.log(this.agentscriptservice.AlldataArray)
    // console.log(this.apiservice.gensysdata.geneSysData.phonenumber)
  }
  constructor(private localStorageService:LocalStorageService,private _elementRef: ElementRef, private attachmentsService: AttachmentsService,private fileUploadService: FileuploadService,private _standardUiService: StandardUIService,public dialog: MatDialog, private fb: FormBuilder,private agentscriptservice:AgentscriptService_updated,private objectcontrolservice:ObjectController) {

  }
  associateditem: any=0
  toggleAssociate(item: any) {
    console.log(item)
    // this.indexassociated=index
    this.associateditem = item
    // this.Associated = true;
    console.log(this.associateditem)

    this.agentscriptservice.updateOrInsertArray(this.tab_title, "associateddata", item)
    this.agentscriptservice.updateOrInsertArray(this.tab_title, "isassociated", true)

    // console.log(this.agentscriptservice.AlldataArray['associateddata']?.length>0)
  }

  showAlertforDissociate() {
    Swal.fire({
      // title: '<div class="popup-content"><img src="../../assets/images/fortwayne-logo-agent.svg"  alt="Selected Image" class="selected-image"><div class="popup-text"> <img src="../../assets/images/verified1.gif" class="animated-check" >Disassociate</div></div>',
        title: '<div class="popup-content"><div class="popup-text"> Disassociate</div></div>',
        html: "Are you Sure?",
        imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
        imageHeight: 45,
        type: 'Success',
        showCancelButton: true,
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel'
    }).then((result) => {
        if (result.value) {
          this.disassociate();
        }
    });
}


// testalert()
// {
//   Swal.fire({
//     title: '<div class="popup-content"><img src="../../assets/images/fortwayne-logo-agent.svg"  alt="Selected Image" class="selected-image"><div class="popup-text"> <img src="../../assets/images/info.gif" class="animated-check" >Submitted successfully</div></div>',
//     icon: 'success',
//     showCloseButton: true,
//     showCancelButton: false,
//     focusConfirm: false,
//     confirmButtonText: `
//       Done
//     `,
//     confirmButtonAriaLabel: 'Thumbs up, great!'
//   })
// }
showAlertforSubmit() {


  Swal.fire({
    title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >Submitted successfully</div></div>',
    icon: 'success',
    imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
    imageHeight: 45,
    showCloseButton: true,
    showCancelButton: false,
    focusConfirm: false,
    confirmButtonText: `
      OK
    `,
    confirmButtonAriaLabel: 'Thumbs up, great!'
  }).then((result) => {
    // if (result.value) {
        // this._parent.agentscriptservice_updated.updateOrInsertArray(this._parent.tab_title,'submitandcontinue',true)
        // this._parent.agentscriptservice_updated.submitandcontinue=true;
        // this._parent.agentscriptservice_updated.assign(this._parent.tab_title,true)
        $("[data-closebutton-id='" + this.tab_title+'-closebutton' + "']").trigger('click')
        // $("[data-obj-id='" + 'home' + "']").parent().trigger('click');
        setTimeout(() => {
        $('#mainListTab0').trigger('click');
        },);
        //$("[data-obj-id='" + 'home' + "']").parent().trigger('click');
        // this._parent.agentscriptservice_updated.getuserallnotifications()
        // this._parent.agentscriptservice_updated.getusernotifications()

    // }
});


  // Swal.fire({
  //     title: 'Submitted successfully',
  //     // html: "Are you Sure?",
  //     type: 'Success',
  //     showCancelButton: true,
  //     confirmButtonText: 'OK',
  //     cancelButtonText: 'Cancel'
  // }).then((result) => {
  //     // if (result.value) {
  //     //   this.disassociate();
  //     // }
  // });../../assets/images/fortwayne-logo-agent.svg             ../../assets/images/logo-main.png
}

showAlertforUpdate(referrenceno:any) {

    Swal.fire({
      // title: '<div class="popup-content"><img src="../../assets/images/fortwayne-logo-agent.svg"  alt="Selected Image" class="selected-image"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >Alert Service Request is Updated succesfully <br> ALert SR ID:<span style="color:#275a8a"><u>'+referrenceno+"</span></u>"+'</div></div>',
      title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >Updated successfully</div></div>',
      icon: 'success',
      imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
      imageHeight: 45,
      showCloseButton: true,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: `OK`,
  }).then((result) => {
    $("[data-closebutton-id='" + this.tab_title+'-closebutton' + "']").trigger('click')
        setTimeout(() => {
        $('#mainListTab0').trigger('click');
        },);

});


}

showErrorforSubmit(data) {


  Swal.fire({
    title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/warning.svg" class="animated-check" >Something went wrong,Please try again. If problem persists please contact support.</div></div>',
    html:data,
    icon: 'error',
    imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
    imageHeight: 45,
    showCloseButton: true,
    showCancelButton: false,
    focusConfirm: false,
    confirmButtonText: `OK`,
    cancelButtonText: 'Cancel'
  }).then((result) => {
    // if (result.value) {
        // this._parent.agentscriptservice_updated.updateOrInsertArray(this._parent.tab_title,'submitandcontinue',true)
        // this._parent.agentscriptservice_updated.submitandcontinue=true;
        // this._parent.agentscriptservice_updated.assign(this._parent.tab_title,true)
        // $("[data-closebutton-id='" + this.tab_title+'-closebutton' + "']").trigger('click')
        // $('#mainListTab1').trigger('click');
        //$("[data-obj-id='" + 'home' + "']").parent().trigger('click');
        // this._parent.agentscriptservice_updated.getuserallnotifications()
        // this._parent.agentscriptservice_updated.getusernotifications()

    // }
});


  // Swal.fire({
  //     title: 'Oops...!',
  //     html: 'Something went wrong,Please try again. If problem persists please contact support.', data,
  //     type: 'error',
  //     showCancelButton: true,
  //     confirmButtonText: 'OK',
  //     cancelButtonText: 'Cancel'
  // }).then((result) => {
  //     // if (result.value) {
  //     //   this.disassociate();
  //     // }
  // });
}

  confirmDisassociate() {
    this.showAlertforDissociate()
    // $('.confirmationModal').modal('show');
  }

  disassociate() {
    // Disassociate logic here
    // this.indexassociated=$
    // this.Associated = false;
    // $('.confirmationModal').modal('hide');
    this.associateditem=0
    this.agentscriptservice.updateOrInsertArray(this.tab_title, "associateddata", [])
    this.agentscriptservice.updateOrInsertArray(this.tab_title, "isassociated", false)
  }


  onSubmit() {
    if(this.addressDetailsForm.valid)
    {
      console.log(this.serviceTypeInfo)
    let IncidentPayload: any = {};
    let ContactPayload: any={};
    // let payLoad = [
    //     {
    //       "entityName": "Incident",
    //       "payLoad":
    //     }
    //   ]
    // IncidentPayload['Incident.division'] = this.divId;
    // IncidentPayload['Incident.department'] = this.deptId;
    // IncidentPayload['Incident.casetype'] = this.casetypeId;
    IncidentPayload['Incident.addresstype'] = +this.addressDetailsForm.value.locationDtls.addresstype;
    IncidentPayload['Incident.postalcode'] = this.addressDetailsForm.value.locationDtls.postalcode;
    IncidentPayload['Incident.latitude'] = this.addressDetailsForm.value.locationDtls.latitude;
    IncidentPayload['Incident.longitude'] = this.addressDetailsForm.value.locationDtls.longitude;;
    IncidentPayload['Incident.addressline1'] = this.addressDetailsForm.value.locationDtls.addressline1;
    IncidentPayload['Incident.addressline2'] = this.addressDetailsForm.value.locationDtls.addressline2;
    IncidentPayload['Incident.city'] = this.addressDetailsForm.value.locationDtls.city;
    IncidentPayload['Incident.state'] = this.addressDetailsForm.value.locationDtls.state;
    IncidentPayload['Incident.withinlimits'] = this.addressDetailsForm.value.locationDtls.withinlimits;
    IncidentPayload['Incident.jurisdiction'] = this.addressDetailsForm.value.locationDtls.jurisdiction;
    IncidentPayload['Incident.collectionday']=this.addressDetailsForm.value.locationDtls.collectionday?this.addressDetailsForm.value.locationDtls.collectionday:null;
    IncidentPayload['Incident.sla']=this.addressDetailsForm.value.locationDtls.sla;
    IncidentPayload['Incident.recycleweek']=this.addressDetailsForm.value.locationDtls.recycleweek?this.addressDetailsForm.value.locationDtls.recycleweek:null;
    IncidentPayload['Incident.zoning']=this.addressDetailsForm.value.locationDtls.zoning;
    IncidentPayload['Incident.parcelnumber']=this.addressDetailsForm.value.locationDtls.parcelnumber;
    IncidentPayload['Incident.furtherdetails'] =this.addressDetailsForm.value.contactDtls.Furtherdetails ;
    IncidentPayload['Incident.subject'] = this.addressDetailsForm.value.contactDtls.alertsubject;
    IncidentPayload['Incident.incidentstatus'] =2
    if(this.updatealertincident!=0)
    IncidentPayload['Incident.id'] =this.updatealertincident


    IncidentPayload['Incident.incidenttypeworkspace'] =197
    IncidentPayload['Incident.createdid'] =JSON.parse(this.localStorageService.get('currentUser')).id

    IncidentPayload['Incident.contactid']=11
    IncidentPayload['Incident.refno'] = $(".custom-tabs li.active").find("a").attr('data-obj-title')

    if(this.associateditem!=0)
    {
      IncidentPayload['Incident.parentid']=this.associateditem.id
    }
    // ContactPayload['Contact.email']="Anonymous@invalid.com.invalid",
    // ContactPayload['Contact.firstname']="Anonymous",
    // ContactPayload['Contact.lastname']="Anonymous",
    // console.log(ContactPayload)
    console.log(IncidentPayload);

    let alertpayload = [
      // {entityName:'Contact',payLoad:ContactPayload},
      { entityName: 'Incident', payLoad: IncidentPayload }
    ];
    console.log(alertpayload)
// console.log(this.addressDetailsForm.value.contactDtls.addresstype1)
// $('#submit').modal('show');
// return false;
console.log(this.addressDetailsForm.valid)
    if (this.addressDetailsForm.valid) {

      // const formData = this.addressDetailsForm.value;
      // console.log(formData)
this.objectcontrolservice.onSaveObject(alertpayload).subscribe((data: any) => {
  console.log(data)
  if(data[0].hasOwnProperty('error') && data[0].error!= null)
  {
    this.showErrorforSubmit(data[0].error)
  }
  else{
    if(this.updatealertincident==0)
      {
    this.showAlertforSubmit()
      }
      else
      {
        this.showAlertforUpdate(this.tab_title)
      }
      console.log(this.fileToUpload)
        if(this.fileToUpload!=undefined && this.fileToUpload!=null)
          {
            this.contextid={"id":data[0].payLoad.id}

            this.attachfile()
            // this.contextid=data[0].payLoad.id
          }

  }

})
    }
    }
    else
    {
      this.formsubmitted=true
    }
    const fieldNamesMap: { [key: string]: string } = {
      addressline1: 'Service Address is required field.',
      alertsubject:'Alert subject is required field',
      Furtherdetails:'Further Details is required field',

      // Add more mappings here as needed
    };

    const excludedFields = ['city', 'state', 'latitude', 'longitude', 'postalcode', 'withinlimits'];

    if (this.addressDetailsForm.invalid) {
      const invalidFields = [];
      const controls = this.addressDetailsForm.controls;

      Object.keys(controls).forEach(groupName => {
        const group = controls[groupName];
        if (group.invalid) {
          Object.keys(group['controls']).forEach(fieldName => {
            const field = group.get(fieldName);
            if (field?.invalid && !excludedFields.includes(fieldName)) {
              invalidFields.push(fieldNamesMap[fieldName] || fieldName);
            }
          });
        }
      });

      // Display alert with invalid fields
     console.log(invalidFields);
     if(invalidFields.length > 0)
     {
      {
        Swal.fire({
          title: '<div class="popup-content"> <div class="popup-text"><img src="../../assets/images/warning.svg" class="animated-check"> Please enter all the required fields</div></div>',
          html: `<ul style="text-align: center; padding-left: 20px; color: red;font-size: 12px;">${invalidFields.map(field => `<li style="margin-bottom: 5px;">${field}</li>`).join('')}</ul>`,
          imageUrl: "https://fortwayne.thesmartcity311.com/assets/images/fort-wayne-logo-seal-dark.svg",
          imageHeight: 45,
          icon: 'error',
          showCloseButton: true,
          showCancelButton: false,
          confirmButtonText: 'OK',
        });
       }
     }


     else if (!this.isGisVerified && this.addressDetailsForm?.get('locationDtls.addressline1')?.value != '') {
      // Handle GIS verification
      console.log("in else")
      this.keyupenter();
    }

    }
    // console.log(!this.isGisVerified)
    // console.log(this.addressDetailsForm?.get('locationDtls.addressline1')?.value)


  }
  getImageSrcforActiveService(casetype_name: string): string {
    return 'assets/images/casetypeImage/'+casetype_name.replace(/\s|\/+/g, "").toLowerCase()+'.svg';
  }
  clearmap() {
    this.EsriMapComponent.addressvalue = ''
    this.EsriMapComponent.initializeMap()
  }
  clearForm() {

    // this.EsriMapComponent.addressvalue=''
    // this.EsriMapComponent.initializeMap()
    this.nearbyIncidents = []
    this.addressDetailsForm.get('locationDtls')?.reset();
    // this.addressDetailsForm.reset();
    this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue("1362");
    // this.isLocationSearch =true;
    console.log(this.addressDetailsForm.get(['contactDtls']).value)
    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'contactdata', this.addressDetailsForm.get(['contactDtls']).value)
    console.log(this.agentscriptservice.fetchData(this.tab_title, 'contactdata'))


  }
isAddresstypeChange() {
  this.loadMap_button = true
  this.nearbyIncidents = []
  // this.agentscriptservice.emitAddress('')
  this.EsriMapComponent.searchLocation = ''
  this.EsriMapComponent.addressvalue = ''
  const addressline1Control = this.addressDetailsForm.get(['locationDtls', 'addressline1']);
  // console.log(addressline1Control.value == null || addressline1Control.value == '' || addressline1Control.value == undefined)
  if (!(addressline1Control.value == null || addressline1Control.value == '' || addressline1Control.value == undefined)) {

    this.EsriMapComponent.initializeMap();
  }
  this.isGisVerified = false;

  // this.isLocationSearch = true;
  setTimeout(() => {
    this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.patchValue("");
    this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.patchValue("")
    this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue("")


    this.agentscriptservice.updateOrInsertArray(this.tab_title, 'locationdata', this.addressDetailsForm.get(['locationDtls']).value)

    console.log(this.agentscriptservice.fetchData(this.tab_title, 'locationdata'))


    // this.addressDetailsForm.get(['locationDtls', 'sla'])?.setValue("")
  }, 200)

}
searchLocationEvent(data: any) {
  console.log(data);
  localStorage.setItem("locationInfo", JSON.stringify(data));
  if (data.address_t == "SINGLE_LINE") {
    this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue("1362");
    this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue("");
  } else {
    this.addressDetailsForm.get(['locationDtls', 'addresstype'])?.setValue("1363");
    this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue(data.address2);
  }
  this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(data.address);
  //console.log(this.addressDetailsForm.get(['locationDtls','addressline1'])?.setValue(data.address))
  this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue(data.city);
  this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue(data.state);
  this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue(data.postalcode);
  this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue(data.lon);
  this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue(data.lat);
  this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue('191');
  this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue('193');
  this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue("Commercial");
  this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue('1360');
  this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue('');
  this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue('02-12-02-432-001.000-074');
  // this.addressDetailsForm.get(['locationDtls','sla'])?.setValue('');

  this.agentscriptservice.updateOrInsertArray(this.tab_title, 'locationdata', this.addressDetailsForm.get(['locationDtls']).value)

  console.log(this.agentscriptservice.fetchData(this.tab_title, 'locationdata'))


}
searchAddress: string;
searchAddress1: string;

// @Output() searchAddressClicked = new EventEmitter<string>();

// onSearchClick() {
//   console.log("xfgvbn")
//   // Emit the search address when the search button is clicked
//   this.searchAddressClicked.emit(this.searchAddress);
// }
// onSearch() {

//   // this.isLocationSearch = true;
// this.isGisVerified = true;
//   this.searchAddress=this.addressDetailsForm.value.locationDtls.addressline1;
//   this.searchAddress1=this.addressDetailsForm.value.locationDtls.addressline2;
//   console.log(this.addressDetailsForm.value.locationDtls.addresstype)
//  if(this.addressDetailsForm.value.locationDtls.addresstype == "1362"){
//    this.agentscriptservice.emitAddress(this.searchAddress);
//   }else{
//     var concatenateAddress= this.searchAddress + ' & ' + this.searchAddress1
//     this.agentscriptservice.emitAddress(concatenateAddress);

//   }
// }

onSearchIntersection() {
  this.entiredata = []
  const addline2 = this.addressDetailsForm?.get('locationDtls.addressline2')?.value;

  if (this.addressDetailsForm?.get('locationDtls.addressline1')?.value.includes('&')) {
    this.loadAllData(this.addressDetailsForm?.get('locationDtls.addressline1')?.value, 'Intersection')
  }
  else if (addline2 != null && addline2 != '' && addline2 != undefined) {
    this.loadAllData(this.addressDetailsForm?.get('locationDtls.addressline1')?.value + ' and ' + this.addressDetailsForm?.get('locationDtls.addressline2')?.value, 'Intersection')
  }
  else {
    console.log(this.addressDetailsForm?.get('locationDtls.addressline1')?.value)

    this.loadAllData(this.addressDetailsForm?.get('locationDtls.addressline1')?.value, 'Address')
  }
}

searchelement:any

fetchaddressdetails: any;
// Within Limits picklist value 192 = Outside Fort Wayne, treated like an address outside city limits
outsidecitylimits: string = '192';
isOutsideCityLimits(data: any) {
  return String(data?.address_details?.within_limits ?? '') == this.outsidecitylimits;
}
loadAllData(item: any, type: any) {
  console.log("loadMap", item)
  let casetypeid =293;
  var streetAddress = item.split(',')[0].trim();
  console.log(streetAddress)
  this.agentscriptservice.fetchaddressdetails(streetAddress, type, casetypeid).subscribe((data: any) => {
    this.fetchaddressdetails = data

    if (data?.status == "NOTOK" || this.isOutsideCityLimits(data)) {
      // alert('Given address is either not in Fort Wayne City limits or not a valid address')

      Swal.fire({
        title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/warning.svg" class="animated-check" >Given address is either not in Fort Wayne City limits or not a valid address</div></div>',
        imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
        imageHeight: 45,
        showCloseButton: true,
        icon: 'error',
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText: `OK`,
        cancelButtonText: 'Cancel'
      })

      this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue('')
      this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue('')

      const issame = document.querySelector('input[type="checkbox"][id="sameAsServiceAddress"]');
        if (issame) {
          (issame as HTMLInputElement).checked = false;
        }
    }
    else {
      console.log(this.fetchaddressdetails)

      this.agentscriptservice.locationcoordinates = this.fetchaddressdetails

      const coords = {
        msr_addresstype: this.fetchaddressdetails?.address_type,
        msr_serviceaddress: this.fetchaddressdetails?.returned_address,
        msr_city: this.fetchaddressdetails?.personal_data?.property_address_city,
        msr_state: this.fetchaddressdetails?.personal_data?.mailing_state,
        msr_zip: this.fetchaddressdetails?.address_details?.zip,
        msr_withinlimits: this.fetchaddressdetails?.address_details?.within_limits,
        msr_recycleweek: this.fetchaddressdetails?.address_details?.recycle_week_ID,
        msr_collectionday: this.fetchaddressdetails?.address_details?.collection_day,
        msr_jurisdiction: this.fetchaddressdetails?.address_details?.jurisdiction,
        msr_next_collection_day: this.fetchaddressdetails?.address_details?.next_collection_day,
        msr_zoning: this.fetchaddressdetails?.address_details?.zoning_id,
        msr_lat: this.fetchaddressdetails?.lat,
        msr_lng: this.fetchaddressdetails?.lng,
        msr_parcelnumber: this.fetchaddressdetails?.personal_data?.parcel_number,
        msr_nearbyIncidents: this.fetchaddressdetails?.nearby_incidents,
        msr_alertIncidents: this.fetchaddressdetails?.nearby_alert_incidents
        // msr_parcelnumber: this.fetchaddressdetails?.personal_data.parcel_number,
      };

      this.agentscriptservice.updateOrInsertArray(this.tab_title, "mapdata", data)

      console.log(this.agentscriptservice.fetchData(this.tab_title, 'mapdata'))

      console.log(coords)

      if (this.fetchaddressdetails?.address_type != null && this.fetchaddressdetails?.address_type != '' && this.fetchaddressdetails?.address_type != undefined) {
        this.isGisVerified = true
      }

      // this.childComponentValue.emit(coords);

      this.receiveData(coords)
      console.log(this.agentscriptservice.fetchData(this.tab_title, 'mapdata'))
      // this.loadmapping(response)
    }


  })
}
  showEsri: boolean = true;
  showGoogle: boolean = false;
  LoadMap() {

    console.log("clicked on loadmap")
    const addline2 = this.addressDetailsForm?.get('locationDtls.addressline2')?.value;
    const addline1 = this.addressDetailsForm?.get('locationDtls.addressline1')?.value;
    if (addline2 != null && addline2 != '' && addline2 != undefined) {
      this.onLoadMap({ text: this.addressDetailsForm?.get('locationDtls.addressline1')?.value + ' and ' + this.addressDetailsForm?.get('locationDtls.addressline2')?.value })
    }
    else if (addline1 != null && addline1 != '' && addline1 != undefined) {
      this.onLoadMap({ text: this.addressDetailsForm?.get('locationDtls.addressline1')?.value })
    }
    else {
      this.EsriMapComponent.addressvalue = ''
      this.EsriMapComponent.initializeMap()
    }
  }
  onLoadMap(item: any) {
    // alert('')
    // this.nearbyIncidents=[]

    //   // this.isLocationSearch = true;
    // this.isGisVerified = true;
    //   this.searchAddress=this.addressDetailsForm.value.locationDtls.addressline1;
    //   this.searchAddress1=this.addressDetailsForm.value.locationDtls.addressline2;
    //   console.log(this.addressDetailsForm.value.locationDtls.addresstype)
    //  if(this.addressDetailsForm.value.locationDtls.addresstype == "1362"){
    //    this.agentscriptservice.emitAddress(this.searchAddress);
    //   }else{
    //     var concatenateAddress= this.searchAddress + ' & ' + this.searchAddress1
    //     this.agentscriptservice.emitAddress(concatenateAddress);

    //   }
    this.isLocationSearch = true;
    // this.isGisVerified = true;
    this.searchAddress = this.addressDetailsForm.value.locationDtls.addressline1;
    this.searchAddress1 = this.addressDetailsForm.value.locationDtls.addressline2;
    console.log(this.addressDetailsForm.value.locationDtls.addresstype)
    console.log(this.searchAddress)
    // this.agentscriptservice.addresstobesearched = item
    this.agentscriptservice.locationcoordinates = this.fetchaddressdetails
    // this.
    console.log(item)
    console.log(item.text)
    if (item.text != null && item.text != '' && item.text != undefined) {
      this.agentscriptservice.emitAddress(item.text);
    }
    else {
      this.EsriMapComponent.addressvalue = ''
      // this.EsriMapComponent.searchLocation=''
      // alert("empty")
      this.EsriMapComponent.initializeMap()

    }

    this.searchelement = item.text;

    this.entiredata = []

    this.showEsri = true;

    // $('#esrimap').trigger('click')
    // this.GoogleMapComponent.showStreetView()

  }
  showEsriMap(event: MouseEvent) {
    // this.class1Active = !this.class1Active;

    this.showEsri =true;

    this.agentscriptservice.emitAddress(this.searchelement);

    event.preventDefault();

  }

  // Method to show Google Map
  showGoogleMap(event: MouseEvent) {

    this.showEsri = false;

    this.agentscriptservice.searchAddress=this.searchAddress;
    event.preventDefault(); // Prevent default behavior of the button


    this.GoogleMapComponent.showStreetView()

  }


showDropdown:boolean=false;
addressSuggestions:any;
entiredata:any;
onDropdownChange(selectedValue: string) {
  this.searchAddress = selectedValue;
//  this.onSearch();
}
addressvalue:any
suggestionSearch() {
  // setTimeout(()=>
  // {

  //   $(this).trigger('click')

  //   // if ($(this).next().is(":hidden")){
  //   //   // $(this).dropdown('toggle');
  //   // }
  //   // $(this).dropdown('open');
  // },1000)

  // const inputElement = this.elementRef.nativeElement.querySelector('[formControlName="addressline1"]');
  // if (inputElement) {
  //           inputElement.dispatchEvent(new Event('click'));
  //       }




  console.log(this.addressvalue);
  if (this.addressDetailsForm?.get('locationDtls.addresstype')?.value == '1362') {
    console.log("1 addressline")
    this.addressvalue = this.addressDetailsForm?.get('locationDtls.addressline1')?.value;
  }
  else {
    console.log("2 addresslines")
    this.addressvalue = this.addressDetailsForm?.get('locationDtls.addressline1')?.value + '%26' + this.addressDetailsForm?.get('locationDtls.addressline2')?.value
  }
  console.log(this.addressvalue)
  this.performAddressSearch(this.addressvalue);

  if (this.addressvalue = this.addressDetailsForm?.get('locationDtls.addressline1')?.value == '') {
    this.entiredata = []
  }
}
isClearable(): boolean {
  return !!this.searchAddress;
}
keyupenter()
  {
    this.entiredata=[]
    const addline2 = this.addressDetailsForm?.get('locationDtls.addressline2')?.value;
    const addline1 = this.addressDetailsForm?.get('locationDtls.addressline1')?.value;
    console.log(addline1)
    console.log(addline2)
    if (addline2 != null && addline2 != '' && addline2 != undefined) {
      console.log("intersection")
      this.assignaddress(this.addressDetailsForm?.get('locationDtls.addressline1')?.value + ' and ' + this.addressDetailsForm?.get('locationDtls.addressline2')?.value)
    }
    else if (addline1 != null && addline1 != '' && addline1 != undefined) {
      console.log("address")
      this.assignaddress( this.addressDetailsForm?.get('locationDtls.addressline1')?.value )
    }
  }
  assignaddress(item: any) {

    this.isGisVerified = false
    this.loadMap_button = true
    console.log("in assign address" + item)
    this.agentscriptservice.updateOrInsertArray(this.tab_title, "isassociated", false)

    this.EsriMapComponent.addressvalue = ''
    this.EsriMapComponent.initializeMap()
    // this.addressDetailsForm.get('locationDtls')?.reset();
    console.log(this.agentscriptservice.fetchData(this.tab_title, 'locationdata'))


    this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'addressline2'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'city'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'state'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'longitude'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'latitude'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'postalcode'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'withinlimits'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'jurisdiction'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'zoning'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'recycleweek'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'collectionday'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'parcelnumber'])?.setValue("")
    this.addressDetailsForm.get(['locationDtls', 'next_collection_day'])?.setValue("")



    this.entiredata = []
    this.nearbyIncidents = []
    this.agentscriptservice.updateOrInsertArray(this.tab_title, "isassociated", false)

    console.log(item)
    // this.onSearch(item);
    var streetAddress = item.split(',')[0].trim();
    this.addressDetailsForm.get(['locationDtls', 'addressline1'])?.setValue(streetAddress)

    // this.
    // this.loadAllData(item,'Address')
    this.onSearchIntersection()

  }
async performAddressSearch(searchTerm: any) {
  console.log(searchTerm)
  if (searchTerm != '') {
    try {
      // Trim the search term to remove any leading or trailing spaces
      // const trimmedSearchTerm = searchTerm.trim();
      const trimmedSearchTerm = searchTerm?.trim();

      console.log(trimmedSearchTerm);

      if (trimmedSearchTerm !== '') { // Check if search term is not empty
        this.agentscriptservice.mapsuggestions(trimmedSearchTerm).subscribe((response: any) => {
          console.log(response.suggestions);
          this.entiredata = response.suggestions;
          const hasMainAddress = this.entiredata.some(
            (item: { text: string }) => item.text.toLowerCase().includes("200 e berry st")
          );

          if (hasMainAddress) {
            // Filter out "200E E Berry St" from the array
            this.entiredata = this.entiredata.filter(
              (item: { text: string }) => !item.text.toLowerCase().includes("200e e berry st")
            );
          }
          this.addressSuggestions = response.suggestions.map((suggestion: { text: any; }) => suggestion.text);
          console.log(this.addressSuggestions);
        });
      } else {
        // Clear suggestions if search term is empty
        this.addressSuggestions = [];
      }
    } catch (error) {
      console.error('Error fetching address suggestions:', error);
    }
  }
  else {
    console.log("is empty")
    this.entiredata = []
  }


}
searchAddress2:any;
openActiveSR(){
  let d = { id: "551", name: "240206-000407", type: 'object', entityName: 'Incident',department: "Water Maintenance"};
  console.log("activesrvalues",d);
  this.componentSelection.emit(d);
}

openAlertPage(incident:any)
  {
  console.log(incident)
  this.agentscriptservice.updateOrInsertArray(incident.referenceNumber,'scriptpayloaddata',incident)

  let d = { id: incident.id, name: incident.referenceNumber, type: 'alertincident', entityName: 'opencreatedalert', src: 'https://fortwayne-portal.thesmartcity311.com/assets/images/AlertIncidentActive.svg',tabid:incident.referenceNumber };

    this.componentSelection.emit(d);
  }
}
